<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listBanksAccount"
        :title-table="$t('Bank Accounts')"
        module="bankAccountSettingsModule"
        sort-name="agencia"
        :show-btn-add="verificarPermissao('ROLE_FINAN_INSERIR')"
        :show-action-delete="verificarPermissao('ROLE_FINAN_DELETAR')"
        @add="addNew"
        @edit="edit"
      />
      <FormBankAccount v-else @cancelar="cancelar" />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import mixinsGlobal from '@/mixins'
import { verificarPermissao } from '@/auth/utils'
import FormBankAccount from './forms/FormBankAccount.vue'

export default {
  name: 'BankAccount',
  components: {
    BRow,
    BCol,
    TableComponents,
    FormBankAccount
  },
  mixins: [mixinsGlobal],
  computed: {
    ...mapState('bankAccountSettingsModule', {
      listBanksAccount: (state) => state.listBanksAccount
    })
  },
  data() {
    return {
      verificarPermissao,
      showForm: false,
      columns: [
        {
          label: this.$t('id'),
          field: 'id'
        },
        {
          label: 'Descrição',
          field: 'descricao'
        },
        {
          label: 'Tipo de Conta',
          field: 'tipoConta.descricao'
        },
        {
          label: 'Saldo Inicial',
          field: 'valorSaldoInicial',
          formatFn: this.formatCurrencyBrazil
        },
        {
          label: 'Saldo Atual',
          field: 'valorSaldoAtual',
          formatFn: this.formatCurrencyBrazil
        },
        {
          label: this.$t('Action'),
          field: 'action'
        }
      ],
      pageConfig: {
        page: 1,
        size: 10,
        sort: 'agencia',
        order: 'asc'
      }
    }
  },
  methods: {
    addNew() {
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch(
        'bankAccountSettingsModule/prepareToEditBankAccount',
        data
      )
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
    }
  }
}
</script>
